var React = require('react');

function WarningLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.138 46.975a2.14 2.14 0 01-1.79-3.31l20.23-40.36a1.88 1.88 0 013.58 0l20.18 40.36a2.12 2.12 0 01-.497 2.877 2.14 2.14 0 01-1.543.413H4.388l-.25.02zm.18-2h40.16a.2.2 0 00.11 0 .14.14 0 000-.19l-.09-.14-20.21-40.42-20.21 40.42c-.023.049-.05.096-.08.14a.17.17 0 00.16.22l.16-.03z","key":0}),React.createElement("path",{"d":"M24.318 33.965a1 1 0 01-1-1v-14a1 1 0 012 0v14a1 1 0 01-1 1zm.04 5a1.5 1.5 0 11-.08-3h.09a1.52 1.52 0 011.45 1.42v.08a1.46 1.46 0 01-.41 1 1.498 1.498 0 01-1.05.5z","key":1})]);
}

WarningLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = WarningLight;

WarningLight.default = WarningLight;
